import React, { useState } from "react";
import { Modal, Button } from "carbon-components-react";
import AccordionRapicare from "../AccordionRapicare";

import "./styles.css";

const ModalRapicareModel = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button onClick={() => setShowModal(true)} className="btn-rapicare">
        Modal 2
      </Button>
      <div>
        <Modal
          modalHeading="Modal Rapicare"
          open={showModal}
          onRequestClose={() => setShowModal(false)}
          primaryButtonText="Save"
          secondaryButtonText="Cancel"
          kind="#ff7a59"
        >
          <AccordionRapicare />
        </Modal>
      </div>
    </>
  );
};

export default ModalRapicareModel;
